export default __webpack_public_path__ + "images/02f6914e14de11843584efb41329d100-safe-space-on-LGBTQIA-social-media.svg";